import { colors } from 'styles/colors';

type XCircle1Props = {
  color?: string;
  size?: string;
};

export const XCircle1Icon = ({ size = '24', color = colors.White }: XCircle1Props): JSX.Element => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.4 9.6L9.6 14.4M9.6 9.6L14.4 14.4M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);
